import type { SVGProps } from "react";
export interface PenNibAltIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PenNibAltIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PenNibAltIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.87 22.001v-6.504a1.87 1.87 0 0 1-.74-1.305L10.12 14l.01-.192a1.876 1.876 0 0 1 1.866-1.683l.19.01A1.875 1.875 0 0 1 13.871 14a1.87 1.87 0 0 1-.752 1.496V22a1.125 1.125 0 0 1-2.25 0Zm5.034-16.626.116.006a1.125 1.125 0 0 1 0 2.238l-.116.006H8.096a1.125 1.125 0 0 1 0-2.25z"
      />
      <path
        fill={color}
        d="M14.628 3.846c-.07-.31-.347-.619-.782-.7l-.23-.02h-3.233c-.648 0-1.03.47-1.03.875L9.355 5.1l-.008.338a8.74 8.74 0 0 1-1.626 4.72l-1.27 1.787a1.7 1.7 0 0 0 .036 2.049l5.084 6.69a.53.53 0 0 0 .426.193c.193 0 .347-.08.432-.193l5.083-6.69a1.7 1.7 0 0 0 .037-2.05l-1.27-1.786a8.74 8.74 0 0 1-1.627-4.72l-.006-.338V4zM16.896 5.1a6.47 6.47 0 0 0 1.217 3.754l1.269 1.787.178.274a3.945 3.945 0 0 1-.256 4.44l-5.083 6.691a2.78 2.78 0 0 1-2.23 1.081 2.8 2.8 0 0 1-1.99-.824l-.221-.257-5.085-6.691a3.95 3.95 0 0 1-.078-4.714l1.27-1.787.282-.428c.527-.874.837-1.84.915-2.83l.02-.496V4c0-1.803 1.548-3.126 3.28-3.126h3.232l.322.015c1.596.152 2.957 1.42 2.958 3.11v1.099Z"
      />
    </svg>
  );
}
